import { AddressFormField } from './FormFields/AddressFormField.js';
import { CheckboxFormField } from './FormFields/CheckboxFormField.js';
import { ChipPickerFormField } from './FormFields/ChipPickerFormField.js';
import { DateFormField } from './FormFields/DateFormField.js';
import { DropdownFormField } from './FormFields/DropdownFormField.js';
import { ObjectArrayFormField } from './FormFields/ObjectArrayFormField.js';
import { PricingFormField } from './FormFields/PricingFormField.js';
import { RadioGroupFormField } from './FormFields/RadioGroupFormField.js';
import { ReadOnlyField } from './FormFields/ReadOnlyFormField.js';
import { SwitchFormField } from './FormFields/SwitchFormField.js';
import { TextAreaFormField } from './FormFields/TextAreaFormField.js';
import { TextFormField } from './FormFields/TextFormField.js';
import { TimeFormField } from './FormFields/TimeFormField.js';
import { Form as Form$1 } from './Form.js';
import { FormItem } from './FormItem.js';
import 'react-hook-form';

// --- Dot notation compound component ---
const FormField = {
    Text: TextFormField,
    TextArea: TextAreaFormField,
    Dropdown: DropdownFormField,
    Switch: SwitchFormField,
    Checkbox: CheckboxFormField,
    Date: DateFormField,
    Time: TimeFormField,
    RadioGroup: RadioGroupFormField,
    Address: AddressFormField,
    ChipPicker: ChipPickerFormField,
    ObjectArray: ObjectArrayFormField,
    ReadOnly: ReadOnlyField,
    Pricing: PricingFormField,
};
const Form = Form$1;
Form.Item = FormItem;
Form.Field = FormField;
Form.displayName = 'Form';

export { Form };
//# sourceMappingURL=index.js.map
